import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Inner from "../component/Innerbanner";
import Product from "../component/Products";

function CategoryProduct() {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProductsByCategory = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/api/products/category/${slug}`, {
          params: {
            page: 1,
            limit: 100, // Adjust as needed
          },
        });

        if (response.data.success) {
          setProducts(response.data.data);
          // Set category name from the category object in response
          setCategoryName(response.data.category.name);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchProductsByCategory();
    }
  }, [slug]);

  return (
    <>
      <Inner
        name={categoryName || "Products"}
        title={`Home . ${categoryName || "Products"}`}
      />

      <div className="container my-5">
        {loading ? (
          <div className="text-center py-10 font-custom text-lg">
            Loading products...
          </div>
        ) : (
          <Product products={products} />
        )}
      </div>
    </>
  );
}

export default CategoryProduct;
